import { bind } from 'decko';
import { inject } from 'dependable-react';
import { css } from 'emotion';
import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

import background from '../assets/preview-background.jpg';
import { BREAKPOINT_SMALL } from '../consts/breakpoints';
import { APP_DATA_TOKEN, I18N_TOKEN } from '../services/InjectTokens';
import { AddOn, Wrap } from '../state/models';
import { pushGtmData } from '../utils/gtm';
import { AddOnSelector } from './AddOnSelector';

const main = css`
  padding: 40px 10px;

  background: url(${background});
  background-size: cover;
  background-repeat: no-repeat;
`;

const heading = css`
  padding: 0 20px;
  text-align: center;
  color: #414042;

  margin-bottom: 35px;

  h2 {
    font-size: 24px;
    margin: 0;
    margin-bottom: 15px;
    @media (min-width: ${BREAKPOINT_SMALL}) {
      font-size: 30px;
    }
  }

  p {
    font-size: 16px;
    margin: 0;

    @media (min-width: ${BREAKPOINT_SMALL}) {
      font-size: 18px;
    }
  }
`;

interface IProps {
  moreProducts: Array<AddOn>;
  wraps: Array<Wrap>;
  type: string;
  [key: string]: any;
}

@observer
export class MoreProducts extends React.Component<IProps> {
  private i18n = inject(I18N_TOKEN);
  private appState = inject(APP_DATA_TOKEN);

  @computed
  public get products() {
    const { type } = this.props;

    return this.props[type].map((product: AddOn | Wrap) => ({
      addOnImage: product.previewMobile.smallUrl ? product.previewMobile.smallUrl : product.previewDesktop.smallUrl,
      currency: product.price.currency,
      id: product.id,
      isSelected: product.isSelected,
      message: this.i18n.t(product.descriptionUid),
      price: product.price.amount,
      title: this.i18n.t(product.uid),
    }));
  }

  public render() {
    if (this.props.type === 'wraps') {
      pushGtmData({
        event: 'personalizacija',
        korak: { items: [{ step: `step_packing` }] },
      });
    } else {
      pushGtmData({
        event: 'personalizacija',
        korak: { items: [{ step: `step_upsell` }] },
      });
    }

    return (
      <div className={main}>
        <div className={heading}>
          <h2>{this.i18n.t(`${this.props.type}_title`)}</h2>
          <p>{this.i18n.t(`${this.props.type}_description`)}</p>
        </div>
        <AddOnSelector items={this.products} onSelectedItem={this.onItemSelect} />
      </div>
    );
  }

  @bind
  @action
  private onItemSelect(id: number) {
    const { type, wraps, moreProducts } = this.props;
    const i18n = inject(I18N_TOKEN);

    if (type === 'moreProducts') {
      const product = moreProducts.find((prod) => prod.id === id);
      if (product) {
        pushGtmData({
          event: 'add_to_cart',
          ecommerce: {
            items: [
              {
                item_id: product.id,
                item_name: product.uid,
                item_category: type,
                price: parseFloat(product.price.amount),
              },
            ],
          },
        });
        product.isSelected = !product.isSelected;
      }
    }

    if (type === 'wraps') {
      const wrap = wraps.find((w) => w.id === id);
      if (wrap && wrap.isSelected) {
        wrap.isSelected = false;

        return;
      }
      wraps.forEach((w) => (w.isSelected = false));
      if (wrap) {
        const { translations, currentLanguage } = this.appState;
        //const name: string = translations[currentLanguage][wrap.uid.replace('_', '')];

        const name: string = i18n.t(wrap.uid);

        //console.log(wrap.uid);
        //console.log('tr', translations[currentLanguage]);
        //console.log('name', name);

        pushGtmData({
          event: 'add_to_cart',
          ecommerce: {
            items: [{ item_id: wrap.id, item_name: name, item_category: type, price: parseFloat(wrap.price.amount) }],
          },
        });
        wrap.isSelected = true;
      }
    }
  }
}
